import React, { Component } from "react";
import PropTypes from "prop-types";

class EmailBroadcastAttachments extends Component {
  static propTypes = {
    eblast_attachments: PropTypes.array
  };

  file_name(url) {
    return url.replace(/.*\/.*?-/, "");
  }

  attachments(attachments) {
    return attachments.map((url, index) => {
      return (
        <li key={index}>
          <a href={url}>
            <i className="fa fa-paperclip" /> {this.file_name(url)}
          </a>
        </li>
      );
    });
  }

  render() {
    const attachments = this.props.eblast_attachments;
    if (attachments && attachments.length) {
      return (
        <div clasName="form-group">
          <label>Attachments</label>
          <ul>{this.attachments(attachments)}</ul>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default EmailBroadcastAttachments;
